import { FiAlertTriangle, FiCheckCircle } from 'react-icons/fi';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

export default function ProblemSection() {
  return (
    <section className="py-24">
      <div className="container-page flex flex-col items-center gap-14">
        <SectionHeading
          eyebrow="The problem"
          title="Most AI assistants remember everything — that's the problem"
          description="Off-the-shelf AI chat tools are built to remember names, client details, financial figures, and internal project names, because that context makes answers better. For a business, that's a governance problem: once sensitive information reaches a third-party model, you've lost control of it."
        />

        <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2">
          <Reveal className="card flex flex-col gap-4 p-8">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-danger/10 text-danger">
              <FiAlertTriangle size={20} />
            </span>
            <h3 className="text-xl font-bold text-ink dark:text-white">Off-the-shelf AI tools</h3>
            <p className="text-sm leading-relaxed text-muted dark:text-subtle">
              Names, client details, financial figures, and internal project names are sent straight to the model —
              and once they've reached a third party, you've lost control of them for good.
            </p>
          </Reveal>

          <Reveal delay={0.1} className="card flex flex-col gap-4 border-brand-200 p-8 dark:border-brand-800/60">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-success/10 text-success">
              <FiCheckCircle size={20} />
            </span>
            <h3 className="text-xl font-bold text-ink dark:text-white">Piua AI's approach</h3>
            <p className="text-sm leading-relaxed text-muted dark:text-subtle">
              Sensitive details are stripped out automatically, in real time, before your message leaves for the AI
              model — so the assistant still understands what you're asking, but never actually sees who or what
              you're really talking about.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
